export default __webpack_public_path__ + "static/media/tri-3.a29901c7.svg";